import React, { Fragment } from "react";
import { useActiveBanner } from "../hooks/use-active-banner";
var AnnouncementBanner = function AnnouncementBanner() {
    var banner = useActiveBanner();
    return banner ? /*#__PURE__*/ React.createElement("div", {
        className: "w-full mt-4 pb-3 md:mt-8"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "font-medium text-gray-800 text-center px-4 py-3 bg-makroRustyLight"
    }, banner.text)) : /*#__PURE__*/ React.createElement(Fragment, null);
};
export default AnnouncementBanner;
